import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

const BellIcon = ( {className}: PropsType ): React.ReactElement => (
    <SvgWrapper width={17} height={18} fill='#fff' className={className} viewBox='0 0 17 18' xmlSpace='preserve'>
        <path
            fill='#fill'
            fillRule='evenodd'
            d='M8.719 15.698a1 1 0 011.73 1.004 2.6 2.6 0 01-4.498 0 1 1 0 011.73-1.004.6.6 0 001.038 0zM8.2 0A5.8 5.8 0 0114 5.8c0 2.287.41 3.998 1.078 5.221.37.677.707 1.034.877 1.147.823.549.434 1.832-.555 1.832H1c-.99 0-1.378-1.283-.555-1.832.17-.113.508-.47.877-1.147C1.99 9.798 2.4 8.087 2.4 5.8A5.8 5.8 0 018.2 0zm0 2a3.8 3.8 0 00-3.8 3.8c0 2.613-.49 4.652-1.322 6.179a8.763 8.763 0 01-.012.021h10.268l-.012-.021C12.49 10.452 12 8.413 12 5.8A3.8 3.8 0 008.2 2z'
        />
    </SvgWrapper>
);

export default BellIcon;
